// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage_errorPage__-gjBu","buttons":"errorPage_buttons__0sCUj","label":"errorPage_label__0Gt15"};